
import i18n from '@/lib/i18n';

// Helper to safely get translation resources
export const getTranslationResources = () => {
  return i18n.options?.resources || {};
};

// Helper to get all translation keys from the resources
export const getTranslationKeys = () => {
  const keys: string[] = [];
  const resources = getTranslationResources();
  
  if (resources?.en?.common) {
    // Extract all keys from the English translations as the base
    const extractKeys = (obj: any, prefix = '') => {
      Object.keys(obj).forEach(key => {
        const fullKey = prefix ? `${prefix}.${key}` : key;
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          extractKeys(obj[key], fullKey);
        } else {
          keys.push(fullKey);
        }
      });
    };
    
    extractKeys(resources.en.common);
  }
  
  return keys.sort();
};

// Helper to get translation value by key
export const getTranslationValue = (locale: string, key: string) => {
  try {
    const resources = getTranslationResources();
    
    if (!resources || !resources[locale] || !resources[locale].common) {
      return '';
    }
    
    const parts = key.split('.');
    let value = resources[locale].common;
    
    for (const part of parts) {
      if (value && typeof value === 'object') {
        value = value[part];
      } else {
        return '';
      }
    }
    
    return typeof value === 'string' ? value : '';
  } catch (error) {
    console.error("Error getting translation value:", error);
    return '';
  }
};

// Helper to check if a translation key exists
export const translationKeyExists = (key: string) => {
  const keys = getTranslationKeys();
  return keys.includes(key);
};

// Helper to create a new translation key with default values
export const createTranslationKey = async (key: string, enValue: string, localeValue: string, locale: string) => {
  try {
    if (!i18n.saveTranslation) {
      throw new Error('saveTranslation method not available');
    }
    
    // First save the English value
    let success = await i18n.saveTranslation('en', key, enValue);
    
    if (!success) {
      throw new Error('Failed to save English translation');
    }
    
    // If locale is not English, save the localized value
    if (locale !== 'en') {
      success = await i18n.saveTranslation(locale, key, localeValue);
      
      if (!success) {
        throw new Error(`Failed to save ${locale} translation`);
      }
    }
    
    return true;
  } catch (error) {
    console.error("Error creating translation key:", error);
    return false;
  }
};
